import { render, staticRenderFns } from "./nodata-add.vue?vue&type=template&id=d3863858&scoped=true&"
import script from "./nodata-add.vue?vue&type=script&lang=js&"
export * from "./nodata-add.vue?vue&type=script&lang=js&"
import style0 from "./nodata-add.vue?vue&type=style&index=0&id=d3863858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3863858",
  null
  
)

export default component.exports